import axios from "axios";
// import { API_URL } from "../../constants";
const API_URL = 'https://media.filmwings.com/';

// 1. Create Event Record First (Sends JSON body)
export const CreateEventApi = async (body, ApiStatus) => {
    if (ApiStatus) ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    try {
        let res = await axios.post(API_URL + "event/create_event", body, {
            headers: {
                'Authorization': "Bearer " + token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if (ApiStatus) ApiStatus({ isLoader: false, isError: false, data: res.data });
        return res.data;
    } catch (err) {
        if (ApiStatus) ApiStatus({ isLoader: false, isError: true, data: null });
        throw err;
    }
};

export const CreateAdpostApi = async (body, ApiStatus) => {
    if (ApiStatus) ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    try {
        let res = await axios.post(API_URL + "posts/create_adpost", body, {
            headers: {
                'Authorization': "Bearer " + token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if (ApiStatus) ApiStatus({ isLoader: false, isError: false, data: res.data });
        return res.data;
    } catch (err) {
        if (ApiStatus) ApiStatus({ isLoader: false, isError: true, data: null });
        throw err;
    }
};

// 2. Upload Individual File Chunk
export const UploadChunkApi = async (formData, onProgress) => {
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    try {
        let res = await axios.post(API_URL + "event/upload_chunks", formData, {
            headers: {
                'Authorization': "Bearer " + token,
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                if (onProgress && progressEvent.total) {
                    const percentCompleted = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    onProgress(percentCompleted);
                }
            }
        });
        return res.data;
    } catch (err) {
        throw err;
    }
};

// 3. Commit All Uploaded Files to the Event ID
export const CommitFilesApi = async (body, ApiStatus) => {
    if (ApiStatus) ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    try {
        let res = await axios.post(API_URL + "event/commit_chunks", body, {
            headers: {
                'Authorization': "Bearer " + token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if (ApiStatus) ApiStatus({ isLoader: false, isError: false, data: res.data });
        return res.data;
    } catch (err) {
        if (ApiStatus) ApiStatus({ isLoader: false, isError: true, data: null });
        throw err;
    }
};